import { render, staticRenderFns } from "./SurveyImage.vue?vue&type=template&id=6a4a9dca&scoped=true&"
import script from "./SurveyImage.vue?vue&type=script&lang=js&"
export * from "./SurveyImage.vue?vue&type=script&lang=js&"
import style0 from "./SurveyImage.vue?vue&type=style&index=0&id=6a4a9dca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4a9dca",
  null
  
)

export default component.exports